// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item[data-v-54855886]{font-size:18px}.v-list-item--active[data-v-54855886]{color:#000!important;background-color:#c8c8c8!important;font-weight:700}.v-list-item--link[data-v-54855886]:before{background-color:transparent!important}.brand[data-v-54855886]{font-size:30px!important}", ""]);
// Exports
module.exports = exports;
